var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNonForecast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#9C1FE9",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2333_49321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.186 9.11797C16.0666 9.0699 15.9334 9.0699 15.814 9.11797L9.846 11.5165L12.25 12.4821L18.404 10.0093L16.186 9.11797ZM19.75 10.5509L13.596 13.0237L16 13.9894L22.154 11.5165L19.75 10.5509ZM23 12.2591L16.5 14.8716V22.8319L23 20.2193V12.2601V12.2591ZM15.5 22.8329V14.8706L9 12.2591V20.2203L15.5 22.8329ZM15.443 8.18449C15.8006 8.0408 16.1994 8.0408 16.557 8.18449L23.686 11.0503C23.7787 11.0876 23.8581 11.1519 23.9141 11.235C23.9701 11.3181 24 11.4162 24 11.5165V20.2203C23.9999 20.4211 23.9399 20.6172 23.8278 20.7834C23.7157 20.9497 23.5566 21.0783 23.371 21.1528L16.186 24.0407C16.0666 24.0887 15.9334 24.0887 15.814 24.0407L8.63 21.1528C8.44425 21.0785 8.28494 20.9499 8.17264 20.7837C8.06034 20.6174 8.00021 20.4212 8 20.2203V11.5165C8.00002 11.4162 8.02994 11.3181 8.08591 11.235C8.14187 11.1519 8.22131 11.0876 8.314 11.0503L15.443 8.18449Z",
    fill: "#9C1FE9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2333_49321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonForecast);
export default __webpack_public_path__ + "static/media/non-forecast.368d38d8d9ba345cd6d7febcf446c83d.svg";
export { ForwardRef as ReactComponent };